import React from 'react';
import './../index.css';

const SHORT_STRING_LENGTH = 400;

export class LevelBooks extends React.Component {

  constructor(props) {
    super(props);
    let booleanArray = new Array();
    for (var ii = 0; ii < this.props.books.length; ii++) {
      if (this.props.books[ii].text.length > SHORT_STRING_LENGTH) {
        booleanArray[ii] = true;
      } else {
        booleanArray[ii] = false;
      }
    }
    this.state = {
      showShort: booleanArray,
    }
  }

  changeSynopsis(index, synopsis) {
    if (this.state.showShort[index]) {
      return synopsis.substring(0, SHORT_STRING_LENGTH) + '...';
    } else {
      return synopsis;
    }
  }

  changeMore(index) {
    let newArray = [...this.state.showShort];
    newArray[index] = !newArray[index];
    this.setState({
      showShort: newArray,
    })
  }

  onClick(url) {
    window.open(url, "_blank");
  }

  render() {
    const books = this.props.books;
    return (
      <>
        {
          /*
          * Level Book section
          */
        }
        {books &&
          <div className='levelBooks'>
            {
              books.map(
                (currentBook, index) =>
                  <table className='book'>
                    <tbody>
                      <tr>
                        <td>
                          <p className='synopsis'>
                            Synopsis:
                          </p>
                          <p className='synopsisText' >
                            <span dangerouslySetInnerHTML={{ __html: '"' + this.changeSynopsis(index, currentBook.text) + '"' }}>
                            </span>
                            {
                              (this.props.books[index].text.length > SHORT_STRING_LENGTH) &&
                              <a className='moreLessLink' href='#' onClick={() => this.changeMore(index)}>
                                {this.state.showShort[index] ? ' Read more...' : ' Read less...'}
                              </a>
                            }
                          </p>
                        </td>
                        <td>
                          <p>
                            <img className='bookImage' alt='' src={currentBook.image} />
                          </p>
                          <p>
                            <input className='openButton' type='button' onClick={() => this.onClick(currentBook.url)}
                              value='PURCHASE' />
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
              )
            }

          </div>

        }
      </>
    );
  }


}
